import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Select, Input, AutoComplete } from "antd";

const { Option } = AutoComplete;

const ActionModal = Form.create()(({ visible, action, onOk, onCancel, form, record, pvs, assets }) => {

  const { getFieldDecorator, validateFields, resetFields } = form;
  const [selectedPv, setSelectedPv] = useState(null)
  const [updatedPvs, setUpdatedPvs] = useState([])
  const [updatedAssets, setUpdatedAssets] = useState([])
  const [selectedPvRecord, setSelectedPvRecord] = useState(null)

  const [selectedAsset, setSelectedAsset] = useState(null)

  useEffect(() => {
    setUpdatedPvs(pvs)
  }, [pvs]);

  useEffect(() => {
    setUpdatedAssets(assets)
  }, [assets]);

  const handleOk = () => {
    validateFields((errors, values) => {
      if (!errors) {
        onOk(values, record, updatedPvs, updatedAssets);
        resetFields();
      }
    });
  };

  // useEffect(() => {
  //   console.log(record)
  // }, [record]);


  const handlePvSelection = (pv) => {
    // console.log(pv)
    setSelectedPv((pvs || []).filter(p => p._id === pv)[0])
  }

  const handleAssetSelection = (asset) => {
    // console.log(asset)
    setSelectedAsset((assets || []).filter(a => a._id === asset)[0])
    setUpdatedAssets((updatedAssets || []).filter(a => a._id !== asset))
  }

  const handlePvListSelection = (pvAssetListId) => {
    const pv = { ...selectedPv };
    setSelectedPvRecord((pv.assetDetails || []).filter(a => a._id === pvAssetListId))
    pv.assetDetails = (pv.assetDetails || []).filter(a => a._id !== pvAssetListId)
    let pvList = [...pvs];
    let newPvList = (pvList || []).filter(p => p._id !== pv._id)
    newPvList.push(pv)
    setUpdatedPvs(newPvList)
  }

  // useEffect(() => {
  //   console.log(selectedPv)
  // }, [selectedPv]);

  return (
    <Modal
      title="Action Form"
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
    >
      <Form layout="vertical">
        {action === 'LINK_TO_PV' && (<>
          <Form.Item name="pv" label="Select PV">
            {getFieldDecorator('pv', {
              rules: [{ required: true, message: 'Please select a PV value!' }],
            })(
              <Select placeholder="Select PV" onChange={handlePvSelection}>
                {
                  (updatedPvs || []).map(pv => <Select.Option value={pv._id}>{pv.pvNo}</Select.Option>)
                }
              </Select>)}
          </Form.Item>
          <Form.Item name="pvNo" hidden={true}>
            {getFieldDecorator('pvNo', {
              initialValue: selectedPv && selectedPv.pvNo, // You can set an initial value if needed
            })(<Input />)}
          </Form.Item>
          <Form.Item name="pv-asset" label="Select pv Asset">
            {getFieldDecorator('pvAsset', {
              rules: [{ required: true, message: 'Please select asset from PV!' }],
            })(
              <Select placeholder="Select PV Asset" onChange={handlePvListSelection}>
                {
                  (selectedPv && selectedPv.assetDetails || []).map(tempAsset => <Select.Option
                    value={tempAsset._id}>{tempAsset.tempAssetCode}</Select.Option>)
                }
              </Select>)}
          </Form.Item>
          <Form.Item name="pvAssetCode" hidden={true}>
            {getFieldDecorator('pvAssetCode', {
              initialValue: selectedPvRecord && selectedPvRecord[0] && selectedPvRecord[0]['tempAssetCode'], // You can set an initial value if needed
            })(<Input />)}
          </Form.Item>
        </>
        )}
        {action === 'LINK_ASSET' && (<>
          <Form.Item name="asset" label="Select Asset">
            {getFieldDecorator('asset', {
              rules: [{ required: true, message: 'Please select an Asset value!' }],
            })(
              <AutoComplete
                // value={value}
                // dataSource={assets}
                style={{ width: 200 }}
                // onSelect={onSelect}
                // onSearch={onAssetSearch}
                onChange={handleAssetSelection}
                placeholder="Select Asset"
                filterOption={(inputValue, option) =>
                  option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
              >{
                  updatedAssets.map(as => <Option key={as._id}>{as.assetCode}</Option>)
                }
              </AutoComplete>
            )}
          </Form.Item>
          <Form.Item name="assetCode" hidden={true}>
            {getFieldDecorator('assetCode', {
              initialValue: selectedAsset && selectedAsset['assetCode'], // You can set an initial value if needed
            })(<Input />)}
          </Form.Item>
        </>
        )}
      </Form>
    </Modal>
  );
});

export default ActionModal;
